<div *ngIf="viewModel$ | async as vm" class="is-flex gap-24">

  <div class="plus-icon-wrapper" *ngIf="!vm.secondTimeRange">
    <div class="plus-icon-container is-cursor-pointer bg-grey-10 text-grey-50 bg-grey-hover-30">
      <app-icon name="plus" class="text-24" (click)="addSecondTimeRange(vm.firstTimeRange, vm.scale)"></app-icon>
    </div>
  </div>

  <div class="second-time-range is-flex" *ngIf="vm.secondTimeRange">
    <app-time-range [selectedTimeRange]="vm.secondTimeRange"
      (selectedTimeRangeChange)="selectSecondTimeRange($event)"
      [scale]="vm.scale">
    </app-time-range>

    <div class="delete-icon-wrapper">
      <div class="delete-icon-container is-cursor-pointer bg-grey-10 text-grey-50 bg-grey-hover-30">
        <app-icon name="close" class="text-24" (click)="deleteSecondTimeRange()"></app-icon>
      </div>
    </div>
  </div>

  <app-time-range [selectedTimeRange]="vm.firstTimeRange"
    (selectedTimeRangeChange)="selectFirstTimeRange($event)"
    [scale]="vm.scale">
  </app-time-range>
</div>